// extracted by mini-css-extract-plugin
module.exports = {"rightCol":"CustomerPortal_rightCol__rjlj1","rightColTracking":"CustomerPortal_rightColTracking__34eZB"};